import http from '@/common/request';

/**
 * 获取验证码
 */
export function getPublicSms(phone) {
  return http.get('/admin/sms/' + phone)
}

/**
 * 授权登录
 */
export function getMemberToken(phone, code) {
  return http.post('/auth/oauth/token?grant_type=mobile&mobile=SMS@' + phone + '&code=' + code,{}, {'headers': {
    'Authorization': 'Basic Ym1zOmJtcw=='
  }})
}

/**
 * 获取用户信息
 */
export function adminUserInfo() {
  return http.get('/admin/user/info')
}

/**
 * 手机号密码登录
 */
export function getPhonePasswordLogin(data) {
  return http.post('/auth/oauth/token', null,
    {
      'headers': {
        'Authorization': 'Basic Ym1zOmJtcw==',
        'CLIENT-TOC': ''
      },
      params: data
    })
}